import { IRevenueAgencyListTableLang } from '../../../types/lang'

export const revenueAgencyListTableLang: IRevenueAgencyListTableLang = {
	revenue_agency_list_table: {
		column_id: 'ID',
		column_name: 'Name',
		column_date_updated: 'Date Updated',
		column_group: 'Group',
		column_percent: 'Percent, %',
		column_is_system: 'System',
		column_is_active: 'Active',
		column_is_hold: 'Hold',
		column_fake_type: 'Fake Type',
		column_history: 'History',
		column_notes: 'Notes'
	}
}